import { ChangeEvent, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useChatOptions } from "../hooks/useChatOptions";
import { FormFactor } from "../types/enums/FormFactor";
import { useFormFactor } from "../hooks/useFormFactor";

export type GlobalSettingsProps = {
  open: boolean;
  currentDefaultSystemPrompt: string;
  currentUseRagByDefault: boolean;
  onSave: (newDefaultSystemPrompt: string, newUseRagByDefault: boolean) => void;
  onClose: () => void;
};

export default function GlobalSettings({
  open,
  currentDefaultSystemPrompt,
  currentUseRagByDefault,
  onSave,
  onClose,
}: GlobalSettingsProps) {
  const [defaultSystemPrompt, setDefaultSystemPrompt] = useState<string>(
    currentDefaultSystemPrompt,
  );
  const [useRagByDefault, setUseRagByDefault] = useState<boolean>(
    currentUseRagByDefault,
  );
  const { chatOptions } = useChatOptions();
  const formFactor = useFormFactor();
  const showRag = chatOptions.show_rag;

  const handleClose = () => {
    setDefaultSystemPrompt(currentDefaultSystemPrompt);
    onClose();
  };

  const handleSave = () => {
    onSave(defaultSystemPrompt, useRagByDefault);
    onClose();
  };

  const handleDefaultSystemPromptChange = (
    event: ChangeEvent<{ value: unknown }>,
  ) => {
    setDefaultSystemPrompt(event.target.value as string);
  };

  const handleUseRagByDefaultChange = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    setUseRagByDefault(event.target.checked);
  };

  const handleResetPrompt = () => {
    setDefaultSystemPrompt(chatOptions.default_system_prompt);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth={true}
      fullScreen={formFactor < FormFactor.Tablet}
    >
      <DialogTitle>Global Settings</DialogTitle>
      <DialogContent>
        <Box>
          <Typography sx={{ fontWeight: "bold" }}>
            These changes will only be applied to newly created conversations.
          </Typography>
        </Box>
        <br />
        <TextField
          sx={{ width: "100%" }}
          multiline={true}
          maxRows={10}
          value={defaultSystemPrompt}
          label={"Default System Prompt"}
          onChange={handleDefaultSystemPromptChange}
        />
        <Button onClick={handleResetPrompt}>Reset</Button>
        <br />
        {showRag ? (
          <></> /*
          <FormControlLabel
            control={
              <Checkbox
                onChange={handleUseRagByDefaultChange}
                name={"RAG"}
                checked={useRagByDefault}
              />
            }
            label={"Use stored documents to inform responses (RAG) by default"}
          />*/
        ) : (
          <></>
        )}
        <Button onClick={() => {}}>Delete all Conversations</Button>
        <Box display="flex" sx={{ mt: "1em" }}>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
